import React from "react";

// const baseURI = 'http://localhost:5000';
const baseURI = 'https://tender.mak.mn';
const baseConfig = {
  makurl: "https://erp.mak.mn",
  // makurl: "http://localhost:8069",
  CompanyId: "MAK",
  loginurl: baseURI,
  baseurl: baseURI,
};
export { baseConfig };



